export default {
    popup: {
        notSubscriber: 'Φαίνεται να μην είσαι πελάτης ΕLPEDISON',
        interestedQuestion: 'Γίνε τώρα πελάτης ELPEDISON και κέρδισε 20€* ΔΩΡΟ στον λογαριασμό σου! Επιπλέον, εξασφάλισε την πραγματικά χαμηλότερη, χωρίς προϋποθέσεις, χρέωση kWh στην αγορά με Δώρο τα 2 πρώτα πάγια!',
        formDescription: 'Συμπλήρωσε τα στοιχεία σου και θα επικοινωνήσουμε μαζί σου χωρίς κανένα κόστος για εσένα!',
        phoneError: '* Μη έγκυρος αριθμός τηλεφώνου',
        timeFramePrefer: 'Τι ώρα να σας καλέσουμε;',
        submit: 'ΥΠΟΒΟΛΗ',
        terms: 'Όροι και προϋποθέσεις',
        databaseSync: 'Η βάση των συνδρομητών μας ανανεώνεται κάθε 24 ώρες',
        fullNameMissing: '* Συμπλήρωσε το ονοματεπώνυμο σου για να συνεχίσεις'
    },
    headerBar: {
        instructions: 'Συχνές Ερωτήσεις'
    },
    infoBox: {
        rewardText: ['Kέρδισε 20€* ΔΩΡΟ στον', 'Λογαριασμό σου!'],
        bringYourFriends: 'Φέρε τους φίλους σου στην ELPEDISON!\nΓιατί για κάθε φίλο που φέρνεις, κερδίζεις 20€* εσύ  και τουλάχιστον 20€* ο φίλος σου.',
        stepsText: 'Κέρδισε σε 3 ΒΗΜΑΤΑ!',
        step1: 'Συμπλήρωσε τα στοιχεία σου στην φόρμα.',
        step2: 'Λάβε sms με μοναδικό link. Προώθησε το link στους φίλους σου.',
        step3: 'Κέρδισες εσύ... Κέρδισε κι ο φίλος σου.'
    },
    referrerForm: {
        instructions: [
            'Καταχώρησε το',
            'ΑΦΜ',
            ' σου, (αν είσαι ήδη πελάτης ELPEDISON). Θα λάβεις στο ',
            'κινητό',
            ', που θα καταχωρήσεις, με μήνυμα ένα ',
            'μοναδικό link',
            'για να το προωθήσεις σε όσους φίλους θέλεις.',
            'Για κάθε φίλο σου που γίνεται πελάτης ELPEDISON κερδίζεις 20€*.'
        ],
        phoneError: '* Μη έγκυρος αριθμός τηλεφώνου',
        vatError: '* Μη έγκυρο ΑΦΜ',
        submit: 'ΑΠΟΣΤΟΛΗ',
        vat: 'Α.Φ.Μ',
        mobilePhone: 'KINHTO (69XXXXXXXX)',
        success: 'Σύντομα θα λάβετε μήνυμα στο κινητό σας',
        vatNotFound: 'Το ΑΦΜ που καταχώρησες δεν ανταποκρίνεται σε πελάτη ELPEDISON, παρακαλώ πολύ καταχώρησε ξανά το ΑΦΜ σου'

    },
    referralInfoBox: {
        mainText: 'Οι φίλοι σου, σου κάνουν ΔΩΡΟ 20€*!\nΓίνε τώρα πελάτης ELPEDISON με την σύσταση που μόλις έλαβες! Εξασφάλισε πραγματικά σταθερά ανταγωνιστικές τιμές σε ρεύμα και φυσικό αέριο και 20€* έκπτωση στον πρώτο σου λογαριασμό!\n\nΚαι για τον φίλο που σε σύστησε, 20€* ΔΩΡΟ στον λογαριασμό του!',
        seondaryText: 'Ξεκίνησε τώρα συμπληρώνοντας τα στοιχεία σου ώστε να κερδίσεις εσύ και ο φίλος που σε σκέφτηκε!'
    },
    referralForm: {
        instructions: 'Καταχώρησε τα στοιχεία σου και θα σε καλέσουμε άμεσα για να σε ενημερώσουμε για το πως θα γίνεις πελάτης ELPEDISON και θα κερδίσεις αυτά τα μοναδικά δώρα!',
        submit: 'ΥΠΟΒΟΛΗ',
        fullName: 'ΟΝΟΜΑΤΕΠΩΝΥΜΟ',
        phoneNumber: 'ΤΗΛΕΦΩΝΟ ΕΠΙΚΟΙΝΩΝΙΑΣ',
        preferredTimeFrame: 'Τι ώρα να σε καλέσουμε;',
        fullNameMissing: '* Συμπλήρωσε το ονοματεπώνυμο σου',
        timeframeError: '* Επέλεξε ώρα επικοινωνίας',
        success: 'Ένας εκπρόσωπος της ELPEDISON θα επικοινωνήσει άμεσα μαζί σας!'
    },
    privacyPolicy: 'Μάθε για την Πολιτική Προστασίας\nΠροσωπικών Δεδομένων της ELPEDISON',
    terms: 'Όροι και Προϋποθέσεις',
    disclaimer: '* Τα 20€ ΔΩΡΟ αποδίδονται με την μορφή Έκπτωσης σε έναν λογαριασμό'
}
